import { r as registerInstance } from './index-6e9159ae.js';

const AtomicLayoutSection = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.section = undefined;
    this.minWidth = undefined;
    this.maxWidth = undefined;
  }
};

export { AtomicLayoutSection as atomic_layout_section };

//# sourceMappingURL=atomic-layout-section.entry.js.map